import React from 'react';
import { prepareDoctorName } from 'infrastructure/functions';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';

import s from './styles.module.scss';

import type { ISmsCampaign } from 'infrastructure/interfaces';

interface IProps {
  data: ISmsCampaign;
}

const Name: React.FC<IProps> = ({ data }) => {
  return (
    <span className={s.name}>
      <Link to={Routes.patientGuid(data.patient.guid)}>
        {prepareDoctorName({
          firstName: data.patient.firstName,
          lastName: data.patient.lastName,
          title: data.patient.title,
        })}
      </Link>
    </span>
  );
};

export default Name;
